import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../../../ducks/app";
import { menuActions, MenuInCart } from "../../../ducks/menu";
import { orderActions } from "../../../ducks/order";
import { useNavigation } from "../../../hooks/useNavigation";
import { useOrder } from "../../../hooks/useOrder";

export const useOrderHistory = () => {
  const dispatch = useDispatch();
  const { orderHistories } = useOrder();
  const { navigateToTopPage } = useNavigation();

  const handleCancelOrder = useCallback((orderId: string) => {
    dispatch(
      appActions.showModal.started({
        title: "注文をキャンセルします。",
        subTitle: "よろしければ「はい」を押して下さい",
        nextButtonLabel: "はい",
        handleNext: () => {
          dispatch(appActions.showLoading());
          dispatch(
            orderActions.updateOrderStatus.started({
              order_id: orderId,
              status: 9,
              // TODO: change to selected language
              lang: "ja",
              onComplete: () => {
                dispatch(appActions.hideLoading());
                dispatch(
                  orderActions.getOrderHistory.started({ conditions: [] }),
                );
              },
              onSuccess: () => {
                dispatch(appActions.closeModal());
                setTimeout(() => {
                  dispatch(
                    appActions.showModal.started({
                      title: "注文はキャンセルされました。",
                      nextButtonLabel: "閉じる",
                      handleNext: () => dispatch(appActions.closeModal()),
                    }),
                  );
                }, 100);
              },
            }),
          );
        },
        closeButtonLabel: "いいえ",
        handleClose: () => dispatch(appActions.closeModal()),
      }),
    );
  }, []);

  const handleReorder = useCallback(
    (orderId: string) => {
      const order = orderHistories.find((order) => order.id === orderId);

      if (!order) return;

      const menusInCart: MenuInCart[] = order.menus
        .filter((menu) => !menu.coupon)
        .map<MenuInCart>((menu) => ({
          menuId: menu.id,
          menuName: menu.name,
          amount: menu.quantity,
          optionId: menu.options[0]?.id,
          optionName: menu.options[0]?.name,
          isEarlyBird: false,
        }));

      dispatch(menuActions.setMenusToReorder(menusInCart));
      navigateToTopPage();
    },
    [orderHistories],
  );

  return { orderHistories, handleCancelOrder, handleReorder };
};
